<ng-container *ngIf="!is_variable">
  {{minPrice | currency:'GBP':'symbol'}}
</ng-container>
<ng-container *ngIf="is_variable">
  From {{minPrice | currency:'GBP':'symbol'}}
</ng-container>
